// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k8-3";
export var downloadButton = "_k8-4";
export var fileContainer = "_k8-9 _k8-7";
export var fileContainerBase = "_k8-7";
export var fileContainerBaseSm = "_k8-a _k8-7";
export var fileContainerFixedHeight = "_k8-8 _k8-7";
export var fileContainerFixedHeightSm = "_k8-c _k8-a _k8-7";
export var fileContainerSm = "_k8-b _k8-a _k8-7";
export var fileInfo = "_k8-5";
export var fileInfoWidthRestricted = "_k8-6";
export var fileType = "_k8-1";
export var fileTypeName = "_k8-2";
export var fileTypeSm = "_k8-d _k8-1";
export var image = "_k8-0";
export var link = "_k8-f";
export var overflowEllipsis = "_k8-e";